export const COMPONENT_INVENTORY_JSON_PATH = 'reports/component_inventory.json';

export const component_inventory_json = COMPONENT_INVENTORY_JSON_PATH;

export default COMPONENT_INVENTORY_JSON_PATH;
